import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#03060B] pt-20 pb-10" data-testid="main-footer">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-14 left-1/2 -translate-x-1/2 select-none whitespace-nowrap font-serif text-[16vw] leading-none tracking-tight text-white/[0.025]"
      >
        MEDIOLANUM
      </span>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size={38} />
              <div className="leading-none">
                <p className="font-serif text-lg tracking-[0.18em] text-slate-100">MEDIOLANUM</p>
                <p className="mt-1 font-mono text-[10px] tracking-[0.42em] text-gold">CONSULTING</p>
              </div>
            </div>
            <p className="mt-5 text-sm font-light leading-relaxed text-slate-400">
              {t("Consulenza societaria, fiscale e operazioni straordinarie. Uno studio milanese a presidio diretto dei soci.")}
            </p>
          </div>

          <div>
            <p className="eyebrow mb-5">{t("Studio")}</p>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/chi-siamo" className="transition-colors hover:text-gold" data-testid="footer-link-chi-siamo">{t("Chi Siamo")}</Link></li>
              <li><Link to="/servizi" className="transition-colors hover:text-gold" data-testid="footer-link-servizi">{t("Servizi")}</Link></li>
              <li><Link to="/team" className="transition-colors hover:text-gold" data-testid="footer-link-team">Team</Link></li>
              <li><Link to="/insights" className="transition-colors hover:text-gold" data-testid="footer-link-insights">{t("News & Insights")}</Link></li>
              <li><Link to="/area-riservata" className="transition-colors hover:text-gold" data-testid="footer-link-area-riservata">{t("Area Riservata")}</Link></li>
              <li><Link to="/privacy" className="transition-colors hover:text-gold" data-testid="footer-link-privacy">{t("Privacy & Cookie Policy")}</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-5">{t("Le Sedi")}</p>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex gap-3">
                <MapPin size={15} className="mt-0.5 shrink-0 text-gold" />
                <span><span className="text-slate-200">{t("Sede Legale")}</span><br />Via Card. Branda Castiglioni 2/1<br />20156 Milano (MI)</span>
              </li>
              <li className="flex gap-3">
                <MapPin size={15} className="mt-0.5 shrink-0 text-gold" />
                <span><span className="text-slate-200">{t("Sede Operativa")}</span><br />Via Panfilo Castaldi 8<br />20124 Milano (MI)</span>
              </li>
              <li className="text-xs text-slate-500">{t("Si riceve previo appuntamento")}</li>
            </ul>
          </div>

          <div>
            <p className="eyebrow mb-5">{t("Contatti")}</p>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-center gap-3">
                <Phone size={15} className="shrink-0 text-gold" />
                <a href="tel:+390235983003" className="transition-colors hover:text-gold" data-testid="footer-phone">
                  Tel. +39 0235983003
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} className="shrink-0 text-gold" />
                <a href="mailto:info@mediolanumconsulting.com" className="break-all transition-colors hover:text-gold" data-testid="footer-email">
                  info@mediolanumconsulting.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} className="shrink-0 text-gold" />
                <a href="mailto:mediocons@pec.it" className="transition-colors hover:text-gold" data-testid="footer-pec">
                  PEC: mediocons@pec.it
                </a>
              </li>
              <li><Link to="/contatti" className="text-gold-light transition-colors hover:text-gold" data-testid="footer-cta-contatti">{t("Modulo di richiesta riservata")}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-legal">
            {t("Mediolanum Consulting Srl — P.IVA / C.F. 14419200960 — REA MI-2781751 — Cap. Soc. € 10.000,00 — Via Card. Branda Castiglioni 2/1, 20156 Milano")}
          </p>
          <p>{t("© 2026 Mediolanum Consulting Srl. Tutti i diritti riservati.")}</p>
        </div>
      </div>
    </footer>
  );
}
